const beneficios = [
  { icon: 'ri-money-dollar-circle-line', text: 'Redução legal da carga tributária' },
  { icon: 'ri-shield-check-line', text: 'Conformidade fiscal garantida' },
  { icon: 'ri-bar-chart-line', text: 'Relatórios gerenciais precisos' },
  { icon: 'ri-search-eye-line', text: 'Identificação de créditos tributários' },
  { icon: 'ri-refresh-line', text: 'Regularização de pendências fiscais' },
  { icon: 'ri-lightbulb-flash-line', text: 'Decisões baseadas em dados reais' },
];

export default function FolderTributario() {
  return (
    <div
      className="relative overflow-hidden flex flex-col"
      style={{
        width: '390px',
        height: '693px',
        background: '#f8f5ef',
      }}
    >
      {/* Top dark header */}
      <div className="absolute top-0 left-0 w-full h-[220px] bg-[#0f2651]" />

      {/* Gold accent top */}
      <div className="absolute top-0 left-0 w-full h-[3px] bg-gradient-to-r from-[#c9a84c] via-[#e8c96a] to-[#c9a84c]" />

      {/* Decorative circle */}
      <div className="absolute top-[-60px] right-[-60px] w-48 h-48 rounded-full border-2 border-[#c9a84c]/20" />
      <div className="absolute top-[-30px] right-[-30px] w-32 h-32 rounded-full border border-[#c9a84c]/15" />

      {/* Bottom gold accent */}
      <div className="absolute bottom-0 left-0 w-full h-[3px] bg-gradient-to-r from-[#c9a84c] via-[#e8c96a] to-[#c9a84c]" />

      <div className="relative z-10 flex flex-col h-full">
        {/* Header */}
        <div className="px-8 pt-7 pb-5">
          <div className="flex items-center justify-between mb-5">
            <div>
              <div className="text-white font-bold text-2xl tracking-tight" style={{ fontFamily: 'Georgia, serif' }}>RCP</div>
              <div className="text-[#c9a84c] text-[9px] font-bold tracking-[0.2em] uppercase mt-0.5">Inteligência Contábil &amp; Tributária</div>
            </div>
            <div className="bg-[#c9a84c]/20 border border-[#c9a84c]/40 rounded-md px-2 py-1 text-right">
              <div className="text-[#c9a84c] text-[8px] font-bold tracking-widest uppercase">CRC RS 011307/O-2</div>
            </div>
          </div>

          {/* Hero image in header */}
          <div className="rounded-xl overflow-hidden" style={{ height: '140px' }}>
            <img
              src="https://public.readdy.ai/ai/img_res/08484a38f55a6520e7a3b2b1bea376f4.jpg"
              alt="Planejamento Tributário RCP"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>

        {/* White content area */}
        <div className="flex-1 bg-[#f8f5ef] px-8 pt-5 pb-6 flex flex-col">
          {/* Badge */}
          <div className="inline-flex items-center gap-1.5 bg-[#c9a84c]/15 border border-[#c9a84c]/30 rounded-full px-3 py-1 mb-3 self-start">
            <div className="w-3 h-3 flex items-center justify-center text-[#c9a84c]">
              <i className="ri-funds-line text-[10px]" />
            </div>
            <span className="text-[#a07a28] text-[9px] font-bold tracking-widest uppercase">Planejamento Tributário</span>
          </div>

          <h2 className="text-[#0f2651] font-bold leading-tight mb-2" style={{ fontSize: '19px', fontFamily: 'Georgia, serif' }}>
            Sua empresa pode estar<br />
            <span className="text-[#c9a84c]">pagando impostos a mais.</span>
          </h2>

          <p className="text-gray-500 text-[10px] leading-relaxed mb-4">
            Com planejamento tributário estratégico, identificamos o enquadramento ideal e reduzimos sua carga fiscal de forma legal e sustentável.
          </p>

          {/* Benefits */}
          <div className="grid grid-cols-2 gap-2 mb-4">
            {beneficios.map((b) => (
              <div key={b.text} className="flex items-start gap-2 bg-white border border-gray-100 rounded-lg p-2">
                <div className="w-5 h-5 flex items-center justify-center bg-[#0f2651]/8 rounded-md flex-shrink-0 mt-0.5">
                  <i className={`${b.icon} text-[#c9a84c] text-[10px]`} />
                </div>
                <span className="text-gray-600 text-[8px] leading-tight">{b.text}</span>
              </div>
            ))}
          </div>

          {/* Stat highlight */}
          <div className="bg-[#0f2651] rounded-xl px-4 py-3 flex items-center gap-4 mb-4">
            <div className="text-center flex-shrink-0">
              <div className="text-[#c9a84c] font-bold text-2xl" style={{ fontFamily: 'Georgia, serif' }}>10+</div>
              <div className="text-white/50 text-[7px] uppercase tracking-wide">Anos</div>
            </div>
            <div className="w-px h-10 bg-[#c9a84c]/20" />
            <p className="text-white/65 text-[9px] leading-relaxed">
              de experiência em contabilidade, auditoria e planejamento tributário para empresas de todos os portes.
            </p>
          </div>

          {/* CTA */}
          <div className="flex items-center gap-2 mt-auto">
            <div className="flex-1 bg-[#c9a84c] rounded-lg px-3 py-2.5 flex items-center justify-center gap-1.5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-line text-[#0f2651] text-sm" />
              </div>
              <span className="text-[#0f2651] font-bold text-[10px] whitespace-nowrap">(51) 99100-3410</span>
            </div>
            <div className="flex-1 border border-[#0f2651]/20 rounded-lg px-3 py-2.5 flex items-center justify-center gap-1.5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-instagram-line text-[#0f2651] text-sm" />
              </div>
              <span className="text-[#0f2651] font-bold text-[10px] whitespace-nowrap">@inteligenciarcp</span>
            </div>
          </div>

          <div className="mt-3 text-center">
            <span className="text-gray-400 text-[8px]">rcpinteligencia.com.br · Porto Alegre, RS</span>
          </div>
        </div>
      </div>
    </div>
  );
}
